<template>
  <el-dialog v-model="showDialog" :title="$t(`components.create-order.header`)" @close="cancelCreate">
    <el-form ref="dataForm" :model="loadingData" label-position="top" status-icon>
      <!-- Mesh Name -->
      <el-form-item
        prop="title"
        :label="$t('components.create-order.title')"
        :disabled="isFetching"
        :rules="{
          required: true,
          message: $t('error.vuelidate.required'),
          trigger: 'blur',
        }"
      >
        <el-input v-model="loadingData.title" :disabled="isFetching"/>
      </el-form-item>

      <!-- Mesh Description -->
      <el-form-item
        prop="description"
        :label="$t('components.create-order.description')"
        :rules="{
          required: true,
          message: $t('error.vuelidate.required'),
          trigger: 'blur',
        }"
      >
        <el-input v-model="loadingData.description" :disabled="isFetching" :rows="2" type="textarea" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button native-type="submit" type="primary" :disabled="isSubmitting || isFetching || !isInputsValid" class="btn btn-primary" @click="save()">
        {{ $t('components.create-order.save') }}
        <span v-if="isSubmitting" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
      </el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { ElForm, ElMessage} from 'element-plus';
import { Component, Prop, Vue } from 'vue-facing-decorator';

import PreviewRendererVideo from '@/components/features/previewRenderer/PreviewRendererVideo.vue';
import PreviewRendererImg from '@/components/features/previewRenderer/PreviewRendererImg.vue';
import * as ModelService from '@/services/api/modelService';
import { useRouter } from 'vue-router';

interface LoadingData {
  title: string;
  description: string;
}

@Component({
  components: { PreviewRendererImg, PreviewRendererVideo },
  emits: [],
})

export default class CreateTemplate extends Vue {
  @Prop() templateId!: number;
  selected = -1;
  showDialog = true;
  loadingData: LoadingData = {
    title: '',
    description: '',
  };
  router = useRouter();
  isFetching = false
  isSubmitting = false

  mounted(): void {
    this.isFetching = true
    ModelService.getModelProductData(this.templateId).then((data) => {
      this.loadingData.title = data.name;
      this.loadingData.description = data.description;
      this.isFetching = false
    });
  }

  cancelCreate(): void {
    this.router.replace('projects');
  }

  save(): void {
    const dataForm = this.$refs.dataForm as typeof ElForm;
    this.isSubmitting = true
    dataForm?.validate(async (valid: any) => {
      if (valid) {
        ModelService.createFromTemplate(this.templateId, this.loadingData.title, this.loadingData.description).then(async (orderId) => {
          this.isSubmitting = false
          if(!orderId) {
            ElMessage.error(this.$t('error.api.server'));
            return 
          }
          this.router.replace(`/order-workflow?templateId=${this.templateId}&orderId=${orderId}`);
        });
      }
    });
  }

  get isInputsValid(){
    return !!this.loadingData.title && !!this.loadingData.description
  }
}
</script>

<style lang="scss" scoped></style>
